/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { Button, Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
// import custom Component
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TableHeaderForCMSDrugDetail } from './gridComponents/tableHead';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  checkActionAccessByRole,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../../Display/NDC/store/action';
import {
  getCmsDrugByCriteria,
  setCmsDrugDetailTab,
  handleErrorMessages,
  updateAuditClearedIndex,
  dispatchCmsDrugCriteriaList,
  setDetailScreenObj,
  setSearchCmsDrugTab,
  dispatchUpdateAuditClearedIndex,
  dispatchCmsDrugCriteria,
  setPreviousDrugData,
} from '../store/Actions';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  redirectURLLink,
  closeTab,
  handleQuarterFormate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';

const DrugFileDetails = ({ location }) => {
  const history = useHistory();
  const { isReadOnly } = location;
  const dispatch = useDispatch();
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const detailspagetable = useSelector(
    (state) => state.sharedState.CMSDrugFileReducer.searchDrugByCriteriaList
  );
  const auditClearedIndexData = useSelector(
    (state) => state.sharedState.CMSDrugFileReducer.auditClearedIndexData
  );

  const errorMessagesFromRedux = useSelector(
    (state) => state.sharedState.CMSDrugFileReducer.errorMessagesInRedux
  );
  const cmsDrugDetailObj = useSelector(
    (state) => state.sharedState.CMSDrugFileReducer.cmsDrugDetailObj
  );
  const searchCmsDrugTabData = useSelector(
    (state) => state?.sharedState?.CMSDrugFileReducer?.searchCmsDrugObj
  );
  const detailScreenObj = useSelector(
    (state) => state.sharedState?.CMSDrugFileReducer?.detailScreenObj
  );
  console.log({
    detailScreenObj: detailScreenObj,
    searchCmsDrugTabData: searchCmsDrugTabData,
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const searchCmsDrugByCriteriaList = useSelector((state) => {
    return state.sharedState.CMSDrugFileReducer.searchCmsDrugByCriteriaList;
  });
  const [hasAccessbyRole, setHasAccessbyRole] = useState(
    checkActionAccessByRole(
      process.env.REACT_APP_HIDE_RESEARCH_CMS_ROLES,
      kcRoles
    )
  );
  const [fullScreenView, setFullScreenView] = useState(false);

  const [showViewHistory, setShowViewHistory] = useState(false);
  const [corrLinkId, setCorrLinkId] = useState(null);

  const [linkTableName, setLinkTableName] = useState('DRUG_AUDIT');
  const [tableName, setTableName] = useState('DRUG_AUDIT');
  const [showComments, setShowComments] = useState(false);

  const [checkVal, setCheckVal] = useState(false);

  const [keyValue, setKeyValue] = useState([]);

  const [cancelView, setCancelView] = React.useState(false);
  const [saveView, setSaveView] = React.useState(false);
  const [handleTab, setHandleTab] = React.useState(false);
  const [clearedCheckBox, setClearedCheckBox] = React.useState(false);
  const [unClearedCheckBox, setUnClearedCheckBox] = React.useState(false);

  const [disableSaveCancel, setDisableSaveCancel] = React.useState(
    cmsDrugDetailObj?.disabledSaveCancelBtn
      ? cmsDrugDetailObj?.disabledSaveCancelBtn
      : false
  );

  const [tableData, setTableData] = useState();

  const [selectedRow, setSelectedRow] = useState();

  const editReduxCmsDrugDetail = (value) =>
    dispatch(setCmsDrugDetailTab(value));

  const [gridAuditParams, setGridAuditParams] = useState(null);
  const [loading, setLoading] = useState(false);
  const setSearchCmsDrug = (value) => dispatch(setSearchCmsDrugTab(value));
  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(dispatchUpdateAuditClearedIndex([]));
  }, []);

  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.detailScreenErrors &&
      !handleTab &&
      errorMessagesFromRedux?.detailScreenErrors.length > 0
    ) {
      var errorMessagesOnly = errorMessagesFromRedux?.detailScreenErrors.filter(
        (item) => item.field !== 'successMessage'
      );
      if (errorMessagesOnly?.length > 0) {
        tabHighLigther('/cmsDrugFileDetail', true);
      } else {
        tabHighLigther('/cmsDrugFileDetail', false);
      }
    } else {
      tabHighLigther('/cmsDrugFileDetail', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // set Initial state values

  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    const tempObj =
      detailspagetable &&
      detailspagetable.map((item) => {
        if (
          item.corrLinkId === corrLinkId &&
          commentsList &&
          commentsList.length > 0
        ) {
          item.ccCommentsExist = 1;
        } else if (item.corrLinkId === corrLinkId) {
          item.ccCommentsExist = 0;
        }
        return item;
      });
    setTableData(tempObj);
    dispatch(dispatchCmsDrugCriteriaList(tempObj));

    if (gridAuditParams && gridAuditParams.api) {
      gridAuditParams.api.refreshCells();
    }
  }, [commentsList]);

  React.useEffect(() => {
    handleScrollToEvent();
    if(detailspagetable&&Array.isArray(detailspagetable)&&detailspagetable.length>0){
   
      detailspagetable.map((dt,i)=>{

        if(dt.terminationDt && dt.drugTerminationDt&&
          dt.terminationDt===dt.drugTerminationDt
        ){
          // dt.drugTerminationDt =""
          // dt.terminationDt =""
          detailspagetable[i].drugTerminationDt = ""
          detailspagetable[i].terminationDt = ""

        }
        if((dt.cmsCosStatusCd === "05" && dt.desiDrugCd === "5")  || ( dt.cmsCosStatusCd === "06" && dt.desiDrugCd === "6" )){
          detailspagetable[i].desiDrugCd = ""
          detailspagetable[i].cmsCosStatusCd = ""
        }
        
      })
      setTableData(detailspagetable);
    }
   

    if (gridAuditParams && gridAuditParams.api) {
      gridAuditParams.api.refreshCells();
    }
    setLoading(false);
  }, [detailspagetable]);

  React.useEffect(() => {
    if (!handleTab) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));

      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/cmsDrugFileDetail' && disableSaveCancel) {
            item.isFormDirty = true;
          } else if (item.navTo === '/cmsDrugFileDetail')
            item.isFormDirty = false;
          return item;
        });

      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [disableSaveCancel]);

  // handle close and confirm popup
  React.useEffect(() => {
    if (!handleTab) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      if (
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.filter((x) => {
          return x.navTo === '/cmsDrugFileDetail' && x.isFormSave;
        }).length > 0
      ) {
        const newObj = updateTabs.map((item) => {
          if (item.navTo === '/cmsDrugFileDetail' && item.isFormSave) {
            item.isFormSave = false;
            onSubmit(false);
          }
          return item;
        });

        localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      }
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const callAPIFunc = () => {
    setLoading(true);
    dispatch(getCmsDrugByCriteria(searchCmsDrugByCriteriaList));
  };
  // handle after call service show success and error message
  React.useEffect(() => {
    if (auditClearedIndexData && auditClearedIndexData.message === 'Success') {
      setSaveView(false);
      setLoading(false);
      if (handleTab) {
        closeTab('/cmsDrugFileDetail', history);
      }
      callAPIFunc();
      var localErr = [];
      localErr.push({
        field: 'successMessage',
        errorType: 'successMessage',
        message: constantMessageData.SUCCESSMESSAGE_GENERIC,
      });

      dispatch(
        handleErrorMessages({
          detailScreenErrors: [...new Set(localErr)],
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
        })
      );
    } else if (auditClearedIndexData === 'failed') {
      setSaveView(false);
      setLoading(false);

      var localErrFail = errorMessagesFromRedux?.detailScreenErrors
        ? errorMessagesFromRedux?.detailScreenErrors
        : [];
      var localErrFail = localErrFail?.filter(
        (item) => item.errorType !== 'successMessage'
      );
      localErrFail.push({
        field: 'failedMessage',
        errorType: 'successMessage',
        message: constantMessageData.FAILED_MESSAGE_GENERIC,
      });

      dispatch(
        handleErrorMessages({
          detailScreenErrors: [...new Set(localErrFail)],
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
        })
      );

      handleScrollToEvent();
    }
  }, [auditClearedIndexData]);

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // handing NDC detail page redirect
  const handleViewDetailsForNDC = async (data) => {
    const response = await getNDCDetails([
      { ndc: data.ndc, drugName: data.drugName },
    ]);
    dispatch(setNDCErrorPopupMessage(null));
    dispatch(setCurrentNDCDetailsIndex(1));
    dispatch(setCurrentNDCDetailsSelected(response[0]));
    dispatch(setNDCDetails([{ ndc: data.ndc, drugName: data.drugName }]));
    redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
  };

  const onSubmit = (value) => {
    if (value) {
      setSaveView(true);
    } else {
      setHandleTab(true);
      saveDrugData();
    }
  };

  // handing view History popup
  const handleViewHistory = () => {
    var select = selectedRow ? { ...selectedRow } : {};
    setShowViewHistory(true);
    const temp = {
      DRUG_SEQ_NUM: select?.drugSeqNum,
      REBATE_PROGRAM_CD: select?.rebateProgramCd,
      QTR: select?.qtr,
      AUDIT_TYPE_CD: select?.auditTypeCd,
    };
    setKeyValue(temp);
  };

  // handing checkbox changes
  const handleOnChangeEvent = async (value, name) => {
    var obj = {
      clearedCheckBox: detailScreenObj?.clearedCheckBox,
      unClearedCheckBox: detailScreenObj?.unClearedCheckBox,
    };
    var dataObj = { ...searchCmsDrugTabData } || {};
    if (name === 'clearedCheckBox') {
      if (!detailScreenObj?.unClearedCheckBox && !value) {
        obj.unClearedCheckBox = true;
        obj.clearedCheckBox = false;
      } else {
        obj.clearedCheckBox = value;
      }
    }

    if (name === 'unClearedCheckBox') {
      if (!detailScreenObj?.clearedCheckBox && !value) {
        obj.clearedCheckBox = true;
        obj.unClearedCheckBox = false;
      } else {
        obj.unClearedCheckBox = value;
      }
    }
    dispatch(setDetailScreenObj(obj));
    var updatedObj = { ...searchCmsDrugByCriteriaList };
    if ('unClearedIndex' in updatedObj) {
      delete updatedObj.unClearedIndex;
    }
    if ('clearedIndex' in updatedObj) {
      delete updatedObj.clearedIndex;
    }

    if (obj && obj.clearedCheckBox) {
      dataObj.state.clearedIndex = true;
      updatedObj = { ...updatedObj, clearedIndex: 1 };
    } else {
      dataObj.state.clearedIndex = false;
    }

    if (obj && obj.unClearedCheckBox) {
      dataObj.state.unclearedIndex = true;
      updatedObj = { ...updatedObj, unClearedIndex: 0 };
    } else {
      dataObj.state.unclearedIndex = false;
    }
    setSearchCmsDrug(dataObj);
    var localErrFail = errorMessagesFromRedux?.detailScreenErrors
      ? errorMessagesFromRedux?.detailScreenErrors
      : [];
    var localErrFail = localErrFail?.filter(
      (item) => item.errorType !== 'successMessage'
    );

    dispatch(
      handleErrorMessages({
        detailScreenErrors: [...new Set(localErrFail)],
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
      })
    );

    setLoading(true);
    dispatch(dispatchCmsDrugCriteria(updatedObj));
    const resultData = await dispatch(getCmsDrugByCriteria(updatedObj));
    if (resultData?.searchDrugByCriteriaList) {
      dispatch(setPreviousDrugData(resultData?.searchDrugByCriteriaList));
    }
    const saveObj = cmsDrugDetailObj || {};
    editReduxCmsDrugDetail({
      ...saveObj,
      disabledSaveCancelBtn: false,
    });
    setDisableSaveCancel(false);
  };

  // handing by default 1st row selection function
  const onGridReadyForDrugAudit = (params) => {
    setGridAuditParams(params);
  };
  // handing save functionality
  const saveDrugData = () => {
    const newObj = detailspagetable?.map((item) => {
      const obj = {
        drugAuditId: {
          drugSeqNum: item.drugSeqNum,
          rebateProgramCd: item.rebateProgramCd,
          qtr: handleQuarterFormate(item.qtr),
          auditTypeCd: item.auditTypeCd,
        },
        auditClearedInd: item.discrepancyClearedInd,
        lastUpdateUserId: logInUser,
      };
      return obj;
    });
    setLoading(true);
    dispatch(updateAuditClearedIndex(newObj));

    setSaveView(false);
    const obj = cmsDrugDetailObj || {};
    editReduxCmsDrugDetail({
      ...obj,
      disabledSaveCancelBtn: false,
    });
    setDisableSaveCancel(false);
  };

  // cancel functionality
  const cancelClearedAuditData = () => {
    setCancelView(false);
    setLoading(true);
    dispatch(getCmsDrugByCriteria(searchCmsDrugByCriteriaList));
    setDisableSaveCancel(false);
    const obj = cmsDrugDetailObj || {};
    editReduxCmsDrugDetail({
      ...obj,
      disabledSaveCancelBtn: false,
    });
  };

  const cellValueUpdateCustom = useCallback((params) => {
    var p = {
      force: params.data,
    };

    params.api.refreshCells(p);
  }, []);

  React.useEffect(() => {
    if (detailScreenObj) {
      setClearedCheckBox(detailScreenObj.clearedCheckBox);
      setUnClearedCheckBox(detailScreenObj.unClearedCheckBox);
    }
  }, [detailScreenObj]);

  return (
    <div
      className='tBillPanel custom-check tabs-container'
      data-testid='cms-drug-detail'
    >
      <CustomSeparator parent1='Research' parent2='CMS Drug File Detail' />
      {!fullScreenView && (
        <>
          <DisplaySuccessMessages
            successMessages={[
              ...new Set(
                errorMessagesFromRedux?.detailScreenErrors?.length > 0
                  ? _.filter(
                      errorMessagesFromRedux?.detailScreenErrors,
                      (l) => l.field === 'successMessage' && l.message
                    ).map((val) => val.message)
                  : []
              ),
            ]}
          />
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesFromRedux?.detailScreenErrors?.length > 0
                  ? _.map(
                      errorMessagesFromRedux.detailScreenErrors?.filter(
                        (item) => item.field !== 'successMessage'
                      ),
                      (l) => l.message
                    )
                  : []
              ),
            ]}
          />
          <Spinner load={loading} />
        </>
      )}
      <SaveCancelPopup
        open={cancelView}
        title='Cancel'
        data-testid='reset-button-uc'
        onConfim={cancelClearedAuditData}
        onCancel={(e) => setCancelView(false)}
        moduleName=''
      />
      <SaveCancelPopup
        open={saveView}
        title='Save'
        data-testid='save-api-uc'
        onConfim={saveDrugData}
        onCancel={(e) => setSaveView(false)}
        moduleName=''
      />

      <div className='row position-relative'>
        {!fullScreenView && (
          <div className='col-12'>
            <div className='btn-wrapper mb-2 float-right'>
              <div className='float-right mt-2 hide-on-print'>
                <Button
                  className='btn btn-success btn-search'
                  data-testid='dfd-save'
                  onClick={() => onSubmit(true)}
                  disabled={!disableSaveCancel || !hasAccessbyRole}
                >
                  <SVGComponent iconName='Icon-awesome-save' /> Save
                </Button>
                <Button
                  className='btn btn-cancel'
                  data-testid='dfd-cancel'
                  onClick={() => setCancelView(true)}
                  disabled={!disableSaveCancel || !hasAccessbyRole}
                >
                  <SVGComponent iconName='Icon-cancel' /> Cancel
                </Button>
              </div>
              <div className='clearfix' />
            </div>
          </div>
        )}
        <div className='col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk'>
          {
            <TableGrid
              data-testid='dfd-details-table'
              rowSelection='single'
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '60vh' : viewPortHeight_355}
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              columnDefs={TableHeaderForCMSDrugDetail}
              rowData={tableData}
              handleViewHistory={handleViewHistory}
              exportFile
              fileName='CMS Drug Discrepancy-details'
              animateRows
              sideBar={false}
              isScrollOn
              onCellValueChanged={(e) => cellValueUpdateCustom(e)}
              frameworkComponents={{
                ActionCellRender: (cellInfo) => {
                  let name = '';
                  if (cellInfo?.colDef?.headerName === 'NDC') {
                    name = cellInfo.data.ndc;
                  }
                  if (cellInfo?.colDef?.headerName === 'Drug Name') {
                    name = cellInfo.data.drugName;
                  }

                  return (
                    <div className='tdCell icon-btn-group'>
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
                      >
                        <Button
                          type='button'
                          data-testid='test-comm-dfd'
                          onClick={() => {
                            setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                            setLinkTableName('DRUG_AUDIT');
                            setTableName('');
                            setShowComments(true);
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setCorrLinkId(
                                cellInfo && cellInfo.data.corrLinkId
                              );
                              setLinkTableName('DRUG_AUDIT');
                              setTableName('');
                              setShowComments(true);
                            }
                          }}
                          className={`th-ic comment-ic ${
                            parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                            1
                              ? 'frr-enabled-comment-btn'
                              : 'frr-disabled-comment-btn'
                          }`}
                          variant='text'
                        >
                          {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                          1 ? (
                            <img
                              aria-label='comment'
                              src={CommentVisibleIcon}
                            />
                          ) : (
                            <img aria-label='comment' src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                    </div>
                  );
                },
                CheckBoxCellRender: (cellInfo) => {
                  cellInfo.value ? setCheckVal(true) : setCheckVal(false);
                  const errorMessagesFromReduxInFrame = useSelector(
                    (state) =>
                      state.sharedState.CMSDrugFileReducer.errorMessagesInRedux
                  );
                  return (
                    <>
                      <div className='tbl-checkbox frr-checkbox-no-label'>
                        <FormControlLabel
                          data-testid='checkBox'
                          label='checkbox'
                          control={<Checkbox color='primary' />}
                          disabled={isReadOnly || !hasAccessbyRole}
                          onChange={(event) => {
                            if (hasAccessbyRole) {
                              const checkedVal = event.target.checked ? 1 : 0;
                              cellInfo.node.setDataValue(
                                cellInfo.column.colId,
                                checkedVal
                              );

                              // Rest of your logic
                              var localErrFail =
                                errorMessagesFromReduxInFrame?.detailScreenErrors ||
                                [];
                              var localErrFail = localErrFail.filter(
                                (item) => item.errorType !== 'successMessage'
                              );

                              dispatch(
                                handleErrorMessages({
                                  detailScreenErrors: [
                                    ...new Set(localErrFail),
                                  ],
                                  searchScreenErrors:
                                    errorMessagesFromReduxInFrame?.searchScreenErrors ||
                                    [],
                                })
                              );
                              const obj = cmsDrugDetailObj || {};
                              editReduxCmsDrugDetail({
                                ...obj,
                                disabledSaveCancelBtn: true,
                              });
                              setDisableSaveCancel(true);
                            }
                            // Prevent default action if hasAccessbyRole is false
                            event.preventDefault();
                          }}
                          checked={parseInt(cellInfo.value, [0, 1]) === 1}
                          value={parseInt(cellInfo.value, [0, 1]) === 1}
                        />
                      </div>
                    </>
                  );
                },
                DrugNameRenderer: (cellInfo) => {
                  if (
                    cellInfo.value !== null &&
                    cellInfo.value !== '' &&
                    cellInfo?.value?.length > 20
                  ) {
                    return (
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip id='labeler-tooltip'>
                            {cellInfo.data.drugName}
                          </Tooltip>
                        }
                      >
                        <div>
                          {cellInfo.data.drugName &&
                            cellInfo.data.drugName.substring(0, 20) + '...'}
                        </div>
                      </OverlayTrigger>
                    );
                  } else {
                    return <div>{cellInfo.value}</div>;
                  }
                },
                NDCCellRender: (cellInfo) => {
                  const [hoverUnder, setHoverUnder] = React.useState(false);

                  return (
                    <div
                      className={
                        hoverUnder ? 'frr-text-decoration-underline' : ''
                      }
                    >
                      <Link
                        to='#'
                        role='button'
                        onClick={() => handleViewDetailsForNDC(cellInfo?.data)}
                        onMouseOver={() => {
                          setHoverUnder(true);
                        }}
                        onMouseOut={() => {
                          setHoverUnder(false);
                        }}
                      >
                        {cellInfo && cellInfo?.data?.ndc}
                      </Link>
                    </div>
                  );
                },
              }}
              onSelect={(e) => {
                setSelectedRow(e.data);
              }}
              gridCall={onGridReadyForDrugAudit}
            />
          }
        </div>
        <div className='frr-cmsdrugfile-setposition'>
          <FormControlLabel
            className='ml-0'
            data-testid='checked_cleared'
            control={<Checkbox color='primary' className='mr-2' />}
            label='Cleared'
            disabled={isReadOnly}
            value={detailScreenObj?.clearedCheckBox}
            checked={clearedCheckBox}
            onChange={(e) =>
              handleOnChangeEvent(e.target.checked, 'clearedCheckBox')
            }
          />
          <FormControlLabel
            className='ml-0'
            data-testid='checked_uncleared'
            control={<Checkbox color='primary' className='mr-2' />}
            label='Uncleared'
            disabled={isReadOnly}
            value={detailScreenObj?.unClearedCheckBox}
            checked={unClearedCheckBox}
            onChange={(e) =>
              handleOnChangeEvent(e.target.checked, 'unClearedCheckBox')
            }
          />
        </div>
      </div>

      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName={linkTableName}
          keyValue={keyValue}
        />
      )}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName={linkTableName}
          corrLinkId={corrLinkId}
        />
      ) : null}
    </div>
  );
};

export default DrugFileDetails;
